var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    fill: "none",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#121331",
    d: "M219.5 377c92.508 0 167.5-74.992 167.5-167.5S312.008 42 219.5 42 52 116.992 52 209.5c0 38.988 13.32 74.864 35.658 103.327l-12.34 65.674 61.636-23.22C161.317 369.106 189.487 377 219.5 377Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#08a88a",
    strokeLinecap: "round",
    strokeMiterlimit: 16,
    d: "M160.009 115.605c-2.538-3.554-15.738 8.921-29.373 27.778s-1.668 57.152 26.617 85.437l44.097 44.097c28.286 28.286 66.508 40.108 85.22 26.328s31.477-26.69 28.504-28.866c-2.974-2.176-11.968-8.704-20.091-14.651s-16.754-12.184-19.219-13.998c-2.466-1.813-9.357 1.523-15.304 7.471-5.947 5.947-12.982 8.558-15.666 5.874l-34.378-34.378-35.393-35.393c-3.264-3.264-1.088-10.734 4.859-16.681s9.138-13.055 7.108-15.811c-2.031-2.829-7.833-10.807-13.055-17.915-5.077-7.035-11.315-15.738-13.926-19.292"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.663fff2cf86356b717c76abf11fdbfd4.svg";
export { ForwardRef as ReactComponent };